export default __webpack_public_path__ + "static/media/Karnataka_Normal.2536e884.svg";